module.exports = __webpack_public_path__ + "static/media/platformFeatures3.7e1d739c.png";